import { Link } from 'react-router-dom'

import { useLang } from '../../context/LangContext'
import { useAuth } from '../../context/AuthContext'
import { MOCK_TICKETS } from '../../services/ticketService'
import StatCard  from '../../components/StatCard/StatCard'
import TicketRow from '../../components/TicketRow/TicketRow'

export default function DashboardPage() {
  const { t } = useLang()
  const { user } = useAuth()

  const total    = MOCK_TICKETS.length
  const inProg   = MOCK_TICKETS.filter((tk) => tk.status === 'in_progress').length
  const resolved = MOCK_TICKETS.filter((tk) => tk.status === 'resolved').length

  const recent = MOCK_TICKETS.slice(0, 3)

  return (
    <div className="page page--card-fill dashboard-page">
      <section className="dashboard-hero-card">
        <div className="dashboard-hero-card__avatar">
          {user?.name?.split(' ').map((name) => name[0]).join('').slice(0, 2) || 'AA'}
        </div>

        <div className="dashboard-hero-card__content">
          <h1>Good morning, {user?.name?.split(' ')[0]}</h1>
          <p>You have {inProg + MOCK_TICKETS.filter((tk) => tk.status === 'open').length} open tickets that need attention</p>
        </div>

        <div className="dashboard-hero-card__actions">
          <Link to="/submit-ticket" className="btn btn--glass">+ New ticket</Link>
          <Link to="/tickets" className="btn btn--glass">My tickets</Link>
        </div>
      </section>

      <div className="stat-grid stat-grid--filled">
        <StatCard title={t('totalTickets')} value={total} colorClass="val--blue" subtitle="All time" icon="🎫" />
        <StatCard title={t('inProgress')} value={inProg} colorClass="val--amber" subtitle="Being handled" icon="⏱" />
        <StatCard title={t('resolved')} value={resolved} colorClass="val--green" subtitle="This month" icon="✓" />
      </div>

      <div className="dashboard-action-grid">
        <Link to="/submit-ticket" className="dashboard-action-card">
          <span className="dashboard-action-card__icon">+</span>
          <span>
            <strong>Submit a ticket</strong>
            <small>Report an issue or request</small>
          </span>
        </Link>

        <Link to="/tickets" className="dashboard-action-card">
          <span className="dashboard-action-card__icon">☷</span>
          <span>
            <strong>Track my tickets</strong>
            <small>View status & replies</small>
          </span>
        </Link>
      </div>

      <section className="section section--filled">
        <div className="section__header">
          <h2 className="section__title">{t('recentTickets')}</h2>
          <Link to="/tickets" className="btn btn--soft section__title--view-all">{t('viewAll')} →</Link>
        </div>

        <div className="ticket-list ticket-list--filled">
          {recent.map((tk) => (
            <TicketRow key={tk.id} ticket={tk} variant="filled" />
          ))}
        </div>
      </section>
    </div>
  )
}
